import { selectFetchStatus, selectOTP, selectUsername } from '../../../../store/forgetPassword/selectors';
import { confirmResetPasswordThunk } from '../../../../store/forgetPassword/thunks';
import { usePasswordValidation } from '../../../../hooks/usePasswordValidation';
import { useDispatch, useSelector } from '../../../../store/store';
import { TypographyLogo } from '../../../../assets/icons/common';
import CheckBox from '../../../../components/CheckBox';
import Button from '../../../../components/Button';
import Input from '../../../../components/Input';
import styles from './style.module.scss';
import { useEffect, useState } from 'react';

type ValidationState = 'NotValidated' | 'Invalid' | 'Valid';

function ResetPassword() {
    const dispatch = useDispatch();
    const OTP = useSelector(selectOTP);
    const [password, setPassword] = useState('');
    const username = useSelector(selectUsername);
    const fetchStatus = useSelector(selectFetchStatus);
    const [confirmPassword, setConfirmPassword] = useState('');
    const { min, num, char, word } = usePasswordValidation(password);
    const [minValidation, setMinValidation] = useState<ValidationState>('NotValidated');
    const [numValidation, setNumValidation] = useState<ValidationState>('NotValidated');
    const [charValidation, setCharValidation] = useState<ValidationState>('NotValidated');
    const [wordValidation, setWordValidation] = useState<ValidationState>('NotValidated');
    const [matchValidation, setMachValidation] = useState<ValidationState>('NotValidated');

    useEffect(() => {
        !min ? setMinValidation('NotValidated') : setMinValidation('Valid');
        !num ? setNumValidation('NotValidated') : setNumValidation('Valid');
        !char ? setCharValidation('NotValidated') : setCharValidation('Valid');
        !word ? setWordValidation('NotValidated') : setWordValidation('Valid');
        (!password || (password !== confirmPassword)) ? setMachValidation('NotValidated') : setMachValidation('Valid');
    }, [min, num, char, word, confirmPassword]);

    const next = () => {
        if ((!min || !num || !char || !word) || (password !== confirmPassword)) {
            !min ? setMinValidation('Invalid') : setMinValidation('Valid');
            !num ? setNumValidation('Invalid') : setNumValidation('Valid');
            !char ? setCharValidation('Invalid') : setCharValidation('Valid');
            !word ? setWordValidation('Invalid') : setWordValidation('Valid');
            (!password || (password !== confirmPassword)) ? setMachValidation('Invalid') : setMachValidation('Valid');
            return;
        }

        setMinValidation('Valid');
        setNumValidation('Valid');
        setCharValidation('Valid');
        setWordValidation('Valid');
        setMachValidation('Valid');

        if (!username || !OTP) return;
        dispatch(confirmResetPasswordThunk({ username, confirmationCode: OTP, newPassword: password }));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Reset password</span>
            </div>
            <Input
                type='password'
                label='New password'
                value={password}
                onChange={setPassword}
            />
            <Input
                type='password'
                label='Confirm password'
                value={confirmPassword}
                onChange={setConfirmPassword}
            />
            <div className={styles.validation}>
                <span
                    className={styles.validation_item}
                    data-validation-status={numValidation}
                >
                    It must contain at least one number
                </span>
                <span
                    className={styles.validation_item}
                    data-validation-status={minValidation}
                >
                    It must contain at least 8 characters
                </span>
                <span
                    className={styles.validation_item}
                    data-validation-status={wordValidation}
                >
                    It must contain at least one capital and one samll letter
                </span>
                <span
                    className={styles.validation_item}
                    data-validation-status={charValidation}
                >
                    It must contain at least one special character (!@#$%^&*)
                </span>
                <span
                    className={styles.validation_item}
                    data-validation-status={matchValidation}
                >
                    The passwords must match
                </span>
            </div>
            <Button
                type='Primary'
                text="Save"
                onClick={next}
                className={styles.next}
                loading={fetchStatus === 'Pending'}
            />
        </div>
    )
}

export default ResetPassword;
